import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/constants/site";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate("/admin", { state: { user: data }, replace: true });
      } catch (err) {
        const detail = err.response?.data?.detail;
        toast.error(typeof detail === "string" ? detail : "Google sign-in failed. Please try again.");
        navigate("/admin", { replace: true });
      }
    })();
  }, [location, navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-[#0B192C] flex items-center justify-center">
      <div className="w-10 h-10 border-2 border-amber-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
